import {SearchTypeAI} from './constants';
import {aiRuleDefaults} from './defaults';
import {AIRule} from './types';

type AIRuleParams = {
	query: string;
};

export const createAIRule = ({query}: AIRuleParams): AIRule => ({
	...aiRuleDefaults,
	elementType: SearchTypeAI,
	elementValue1: query,
});

export default createAIRule;
